<template>
    <div class="bg--gray py-5">
        <div class="container">
            <h1>{{msg}}</h1>
            <div class="buttons__container">
                <button type="button" class="btn btn-link">Link</button>
                <button type="button" class="btn btn-primary">Primary</button>
                <button type="button" class="btn btn-disabled" disabled>disabled</button>
            </div>

            <div class="buttons__container">
                <button type="button" class="btn btn-link btn-link--blue-bg">Link</button>
                <button type="button" class="btn btn-primary btn-primary--blue-bg">Primary</button>
                <button type="button" class="btn btn-disabled btn-disabled--blue-bg" disabled>disabled</button>
            </div>

            <div class="buttons__container">
                <button type="button" class="btn btn-link btn-link--blue-bg">Link</button>
                <button type="button" class="btn btn-primary btn-primary--blue-bg">Primary</button>
                <button type="button" class="btn btn-disabled btn-disabled--blue-bg" disabled>disabled</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Buttons",
        data() {
           return {
               msg: 'Buttons'
           }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables";
    .buttons__container {
        margin-bottom: 2rem;

        &:nth-of-type(2) {
            background-color: $alert-blue;
            padding: 1rem 0;
        }

        &:nth-of-type(3) {
            background-image: url(/static/img/bg.def7445.jpg);
            padding: 1rem 0;
        }
    }

    .btn {
        text-transform: uppercase;
    }

    .btn-primary {
        background-color: $alert-blue;
        border-color: $alert-blue;
        color: #fff;
        border-radius: 2px;

        &:hover {
            background-color: darken($alert-blue, 10%);
        }

        &--blue-bg {
            color: $alert-blue;
            background-color: #fff;
            border-color: #fff;
        }
    }

    .btn-disabled {
        background-color: transparent;

        &--blue-bg {
            color: rgba(0, 0, 0, 0.55);
        }
    }

    .btn-link {
        color: $alert-blue;

        &:hover {
            text-decoration: none;
        }

        &--blue-bg {
            color: #fff;

            &:hover {
                color: #fff;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Buttons.vue